<template>
  <div class="home-page">
    <TickerBanner :ticker-items="tickerItems" />
    <HeroSection />
    <FreeBlindboxSection :cards="blindBoxCards" @card-click="onCardClick" />
    <RusdRewardSection />
    <PartnersSection />
    <FaqSection />
    <PromotionSection />
    <RoadmapSection />
    <HomeFooter />
  </div>
</template>

<script>
import { Notify } from "vant";
import TickerBanner from "@/views/home/components/TickerBanner.vue";
import HeroSection from "@/views/home/components/HeroSection.vue";
import FreeBlindboxSection from "@/views/home/components/FreeBlindboxSection.vue";
import RusdRewardSection from "@/views/home/components/RusdRewardSection.vue";
import FaqSection from "@/views/home/components/FaqSection.vue";
import PartnersSection from "@/views/home/components/PartnersSection.vue";
import PromotionSection from "@/views/home/components/PromotionSection.vue";
import RoadmapSection from "@/views/home/components/RoadmapSection.vue";
import HomeFooter from "@/views/home/components/HomeFooter.vue";
import { fetchHomeLotteryData } from "@/contract/services/lotteryService";
import { HOME_BLIND_BOX_META } from "@/contract/constants";
import { shouldNotifyRpcError } from "@/contract/index";
import { formatTokenAmount } from "@/contract/services/txHelper";
const POLL_INTERVAL_MS = 20000;
console.log(formatTokenAmount("10000000000000000000"),'dqwd')
function buildFallbackCards() {
  return HOME_BLIND_BOX_META.map((item) => ({
    id: item.id,
    name: `${item.namePrefix}(0张)`,
    image: item.image,
    price: item.displayPrice,
    participants: 0,
    latestWinner: "暂无",
  }));
}

export default {
  name: "Home",
  components: {
    TickerBanner,
    HeroSection,
    FreeBlindboxSection,
    RusdRewardSection,
    FaqSection,
    PartnersSection,
    PromotionSection,
    RoadmapSection,
    HomeFooter,
  },
  data() {
    return {
      tickerItems: [],
      blindBoxCards: buildFallbackCards(),
      pollTimer: null,
    };
  },
  mounted() {
    this.loadHomeLotteryData({ silent: true }).catch(() => {});
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.stopPolling();
      this.pollTimer = setInterval(() => {
        this.loadHomeLotteryData({ silent: true }).catch(() => {});
      }, POLL_INTERVAL_MS);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async loadHomeLotteryData({ silent = false } = {}) {
      try {
        const { tickerItems, cards } = await fetchHomeLotteryData();
        this.tickerItems = tickerItems;
        this.blindBoxCards = cards;
      } catch (err) {
        console.error("[首页盲盒数据加载失败]", err);
        if (!silent && shouldNotifyRpcError(err)) {
          Notify({
            type: "danger",
            message: err?.message || "加载盲盒数据失败",
          });
        }
      }
    },
    onCardClick(card) {
      this.$router.push({ path: `/blindbox/${card.id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100%;
  padding-bottom: 20px;
}
</style>
